import React, { useState } from 'react'

import { SearchField } from 'components/common/SearchField'

export const AgentsSearch: React.FC = () => {
  const [searchText, setSearchText] = useState('')

  const handleSearchChange = (value: string) => {
    setSearchText(value)
  }

  const isDisabled = true // TODO: Implement agent search (EN-8282 - https://gremlininc.atlassian.net/browse/EN-8282)

  return (
    <SearchField
      fullWidth
      disabled={isDisabled}
      helperText="Search by name or tag"
      label="Search Placeholder" // TODO: Implement agent search (EN-8282 - https://gremlininc.atlassian.net/browse/EN-8282)
      value={searchText}
      onChange={handleSearchChange}
    />
  )
}
